import _objectSpread from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
export var createPostMessageFactory = function createPostMessageFactory(generateUniqueNumber) {
  return function (ongoingRequests, port) {
    return function (message) {
      var transferables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return new Promise(function (resolve, reject) {
        var id = generateUniqueNumber(ongoingRequests);
        ongoingRequests.set(id, {
          reject: reject,
          resolve: resolve
        });
        port.postMessage(_objectSpread({
          id: id
        }, message), transferables);
      });
    };
  };
};